import React, { Suspense, useState } from 'react'
import { Box, CircularProgress, Tab, Tabs } from '@mui/material'
import { AccountsTab } from './accounts/AccountsTab'
import { UsersTab } from './users/UsersTab'

const TabLoading = () => (
  <div className="flex w-full justify-center p-10">
    <CircularProgress />
  </div>
)

/**
 * Internal admin panel. Routing already restricts this page to super users
 * (non-super users see <AccessDenied/>), but every admin GraphQL operation is
 * additionally gated on the super user flag server-side.
 */
export const AdminPage = () => {
  const [tab, setTab] = useState(0)

  return (
    <div className="flex h-full w-full flex-col p-6">
      <h1 className="mb-4 text-2xl font-semibold text-darkBlue">Admin</h1>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, value) => setTab(value)}>
          <Tab label="Accounts/Brands" />
          <Tab label="Users" />
        </Tabs>
      </Box>
      <div className="mt-4 flex-1 overflow-auto">
        <Suspense fallback={<TabLoading />}>
          {tab === 0 ? <AccountsTab /> : <UsersTab />}
        </Suspense>
      </div>
    </div>
  )
}

export default AdminPage
